(function (global, $) {
    var triggers = document.querySelectorAll('[data-populate-email-trigger]');
    var select = document.querySelector('[data-populate-email-target]');

    if (!triggers && !select) {
        return;
    }

    triggers.forEach(function(trigger) {
        var slug = trigger.dataset.populateEmailTrigger;

        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            populateEmailHandler(slug);
        });
    });

    function populateEmailHandler(slug) {

        // Get the select option that matches the slug
        var currentElement = select.querySelector('option[data-slug="' + slug + '"]');

        // Change the element selected option to the currentElement option
        currentElement.selected = true;
        scrollToContactHandler();
    }

    function scrollToContactHandler() {

        // Get the navigation element
        var navShadow = document.querySelector('[data-nav-shadow]');

        // Get the anchor element with the id #contact
        var contactAnchor = document.querySelector('#contact');

        if(navShadow) {
            var navHeight = navShadow.offsetHeight;
        }
 
        if(contactAnchor) {
            // Scroll to the anchor element
            window.scrollTo({
                top: contactAnchor.offsetTop - navHeight
            });
        }
    }
}(window.groots, jQuery));